var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.social.href,"target":"_blank","rel":"me"}},[_c('div',{staticClass:"icon-cnt",attrs:{"title":_vm.social.name}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.social.icon,"label":_vm.social.name}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }